import { Badge } from '@/components';

// Three honest states (UCH-446): Pending (never dispatched, or dropped by a
// verify), Dispatched (register workflow sent, not yet confirmed on the Apple
// portal), Registered (confirmed present via App Store Connect).
export const UdidStatusBadge = (props: {
  row: { registeredAt: string | null; verifiedAt: string | null };
}) => (
  <Badge
    tone={props.row.verifiedAt ? 'success' : props.row.registeredAt ? 'info' : 'warning'}
    class="self-start"
  >
    {props.row.verifiedAt ? 'Registered' : props.row.registeredAt ? 'Dispatched' : 'Pending'}
  </Badge>
);
